import { Dayjs } from "dayjs";

export interface PayoutTransaction {
    id: ID;
    amount: number;
    balance: number;
    classType: string;
    currency: string;
    earning: number;
    payoutEnd: Dayjs;
    payoutStart: Dayjs;
}

export enum PayoutType {
    Payout = "payout",
    AUTO_PAYOUT = "auto_payout",
}

export interface TopUp {
    accountNumber: string;
    bankName: string;
    id: string;
    remoteId: string;
    remoteSystem: string;
    routingNumber: string;
    stripeCustomer: string;
    swiftCode: string;
}
